/**
 * 邮箱地址与分组API
 * 提供邮箱分组和邮箱地址的CRUD操作
 */
import apiClient from "./axios";

// 邮箱分组相关API
export const emailGroupApi = {
    // 获取可用标签
    getAvailableTags: () => apiClient.get("/v1/email-groups/tags"),

    // 获取分组列表
    getEmailGroupList: (params = {}) => apiClient.get("/v1/email-groups", { params }),

    // 获取分组详情
    getEmailGroupById: (id) => apiClient.get(`/v1/email-groups/${id}`),

    // 创建分组
    createEmailGroup: (data) => apiClient.post("/v1/email-groups", data),

    // 更新分组
    updateEmailGroup: ({ id, data }) => apiClient.put(`/v1/email-groups/${id}`, data),

    // 删除分组
    deleteEmailGroup: ({ id, params = {} }) => apiClient.delete(`/v1/email-groups/${id}`, { params }),
};

// 邮箱地址相关API
export const emailAddressApi = {
    // 获取邮箱地址列表
    getEmailAddressList: (params = {}) => apiClient.get("/v1/email-addresses", { params }),

    // 获取邮箱地址详情
    getEmailAddressById: (id) => apiClient.get(`/v1/email-addresses/${id}`),

    // 创建邮箱地址
    createEmailAddress: (data) => apiClient.post("/v1/email-addresses", data),

    // 更新邮箱地址
    updateEmailAddress: ({ id, data }) => apiClient.put(`/v1/email-addresses/${id}`, data),

    // 删除邮箱地址
    deleteEmailAddress: ({ id, params = {} }) => apiClient.delete(`/v1/email-addresses/${id}`, { params }),

    // 批量更新邮箱地址分组
    batchUpdateAddressGroups: (data) => apiClient.post("/v1/email-addresses/batch-update-groups", data),

    // 批量创建邮箱地址
    batchCreateEmailAddresses: (data) => apiClient.post("/v1/email-addresses/batch-create", data),

    // 批量检查邮箱地址是否存在
    checkEmailAddressesExistence: (emails) => apiClient.post("/v1/email-addresses/check-existence", { emails }),

    // 获取分组下的邮箱地址
    getEmailAddressesByGroup: (groupId, params = {}) => apiClient.get(`/v1/email-groups/${groupId}/addresses`, { params }),

    // 智能添加邮箱到分组（创建新邮箱或添加已存在邮箱到分组）
    addEmailsToGroup: (data) => apiClient.post("/v1/email-addresses/add-to-group", data),
};

export default {
    emailGroup: emailGroupApi,
    emailAddress: emailAddressApi,
};
